import SimpleDate from 'app/common/classes/simple-date'


export type Summary = {
  withOrders: number
  withOrdersExpenses: number
  withOrdersSubsidies: number
}

export type Unperformed = Array<{
  ID: string
  title: string
}>

export type ByClasses = {
  key: string
  _1_4: null | number
  _5_9: null | number
  _10_11: null | number
  total: null | number
  hasDelimiter?: boolean
}

export type TotalItem = {
  key: string
  value: null | number
  hasDelimiter?: boolean
}

export type NumberOfFeeding = Array<ByClasses>
export const numberOfFeedingArrange = ['breakfast', 'dinner', 'afternoon'] as const

export type Org = {
  id: string
  title: string
  numberOf: NumberOfFeeding
}

export type Orgs = {
  items: Array<Org>
  total: Array<TotalItem>
  plannedDate: SimpleDate
  shiftsClasses: Array<number>
  shiftsDayCares: Array<number>
}

export enum OrderByClassesDetailsGroup {
  ByClasses = 'by_classes',
  ByCustomersAndFunds = 'by_customers_and_funds',
  ByFunds = 'by_funds',
}

export type OrgByFunds = {
  orgID: string
  orgTitle: string
  parentsExpensesCount: number
  budgetExpencesFrom1To11Count: Array<number>
  budgetExpencesFrom1To11CountTotal: number
  budgetExpencesFrom1To4Count: number
  totalCount: number
}

export type OrgByFundsTotals = {
  parentsExpensesCount: number
  budgetExpencesFrom1To11Count: Array<number>
  budgetExpencesFrom1To11CountTotal: number
  budgetExpencesFrom1To4Count: number
  totalCount: number
}

export type OrgByCustomersAndFunds = {
  orgID: string
  orgTitle: string
  countFrom1To4: CountInfoType
  countFrom5To11: CountInfoType
}

export type CountInfoType = {
  parentsExpensesCount: number,           // кол-во за родительскую плату
  allowances: {                // кол-во по категориям льгот
    [subsidyType: string]: number
  },
  totalCount: number               // всего за диапазон параллелей
}

export type AllowancesByClasses = {
  countFrom1To4: Array<string>
  countFrom5To11: Array<string>
}

export type OrgByCustomersAndFundsTotals = {
  countFrom1To4: CountInfoType
  countFrom5To11: CountInfoType
}

export type ReportOrdersByClassesData = {
  detailsGroup: OrderByClassesDetailsGroup.ByClasses
  summary?: Summary
  orgs?: Orgs
  unperformed: Unperformed
} | {
  detailsGroup: OrderByClassesDetailsGroup.ByFunds
  orgs: Array<OrgByFunds>
  totals: OrgByFundsTotals
  allowanceIDs: Array<string>
  unperformed: Unperformed
} | {
  detailsGroup: OrderByClassesDetailsGroup.ByCustomersAndFunds
  orgs: Array<OrgByCustomersAndFunds>
  totals: OrgByCustomersAndFundsTotals
  allowances: AllowancesByClasses
  unperformed: Unperformed
}
